<template>
  <v-container fluid :height="windowSize.y * 0.9 - subtractHeight">
    <v-row>
      <v-col colls="6">
        <CalendarDateUserStatisticBeginOne
            ref="CalendarDateUserStatisticBeginOne"
            :user-id="userId"
        >
        </CalendarDateUserStatisticBeginOne>
      </v-col>
      <v-col colls="6">
        <CalendarDateUserStatisticRangeOne
            ref="CalendarDateUserStatisticRangeOne"
            :user-id="userId"
        >
        </CalendarDateUserStatisticRangeOne>
      </v-col>
    </v-row>
    <router-view></router-view>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import CalendarDateUserStatisticRangeOne from "@/components/TimeTracker/CalendarDateUserStatisticRangeOne";
import CalendarDateUserStatisticBeginOne from "@/components/TimeTracker/CalendarDateUserStatisticBeginOne";


export default {
  name: 'CalendarDateUserStatistic',
  props: {
    subtractHeight: {type: [Number], default: 200},
    height: {type: [Number], default: window.innerHeight},
    userId: {default: null},
  },

  components: {
    CalendarDateUserStatisticRangeOne,
    CalendarDateUserStatisticBeginOne,
  },

  computed: {},

  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },

    onUpdateFilters() {
      this.$refs.CalendarDateUserStatisticBeginOne.onUpdateFilters()
      this.$refs.CalendarDateUserStatisticRangeOne.onUpdateFilters()
    },

  },

  async mounted() {
    // console.log('mounted')
  },

  created() {
    // update the time every second
    this.interval = setInterval(() => {
      // Concise way to format time according to system locale.
      // In my case this returns "3:48:00 am"
      this.picker = Intl.DateTimeFormat(navigator.language, {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
      }).format()
    }, 1000)
  },

  beforeDestroy() {
    // prevent memory leak
    clearInterval(this.interval)
  },

  data() {
    return {
      windowSize: {x: 0, y: 0,},
      picker: null,
      search: '',
      floor: null,
    }
  }
}
</script>

<style scoped lang="scss">

</style>
